import React from "react";
import { connect } from "react-redux";
import Container from "../components/Container";

const RetirementNotice = React.createClass({
    propTypes: {
        firstname: React.PropTypes.string,
        lastname: React.PropTypes.string,
        image: React.PropTypes.string,
        notice: React.PropTypes.string,
    },
    render: function () {
        return (
            <Container>
                <div className="retirement-notice-wrapper">
                    <img className="notice-image" src={this.props.image} />
                </div>
            </Container>
        );
    },
});

const mapStateToProps = (state) => {
    return {
        image: state.retirement_notice.image,
    };
};

export default connect(mapStateToProps)(RetirementNotice);



// WEBPACK FOOTER //
// ./src/js/containers/RetirementNotice.js